function QuizGetQuestion(){
    $.post("/upitnik/get-question").done(function(response) {
        $obj = jQuery.parseJSON(response);

        $markup = $obj.data.markup;
        $counter = $obj.data.meta.id;
        $image = $obj.data.meta.image;

        $('.quiz .quiz__form').html($markup);
        $('.quiz .counter .current').html($counter);
        $('.quiz .quiz__bg').css('background-image','url(/images/quiz/'+$image+')');
    });
}



$(document).on('submit', '.quiz .quiz__form', function(e){
    e.preventDefault();

    $.ajax({
        type: "POST",
        url: $(this).attr('action'),
        data: $(this).serialize(),
        success: function(response) {
            if (response == "error") {
                window.location.replace("/");
            }

            if (response == "success") {
                QuizGetQuestion();
            }

            if (response == "finish") {
                window.location.replace("/upitnik/rezultati");
            }
        }
     });
});